import React from "react";
import PropTypes from "prop-types";
const ChatIcon = ({
  noPointer,
  className,
  width,
  size,
  height,
  style,
  color,
  title
}) => (
  <svg
    className={className}
    style={style}
    data-no-pointer={noPointer}
    width={width || size || 24}
    height={height || size || 24}
    viewBox="0 0 22 25"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby="title"
  >
    <title>{title}</title>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g>
        <g>
          <path
            d="M4.36831276,21.608633 L7.61844979,19.7154878 C7.85767868,19.5761413 8.14397127,19.5422078 8.40914663,19.6217686 C9.24191591,19.8716251 10.1117984,20 11,20 C15.9705627,20 20,15.9705627 20,11 C20,6.02943725 15.9705627,2 11,2 C6.02943725,2 2,6.02943725 2,11 C2,13.2641777 2.83800879,15.3951028 4.32697066,17.0392103 C4.50654939,17.2375006 4.59918963,17.4994771 4.58418236,17.766577 L4.36831276,21.608633 Z M8.26068071,21.6559496 L3.76894684,24.2723022 C3.08053032,24.6732921 2.22250756,24.1475382 2.2671997,23.3521056 L2.56452135,18.0603629 C0.920724053,16.0989051 0,13.6200273 0,11 C0,4.92486775 4.92486775,0 11,0 C17.0751322,0 22,4.92486775 22,11 C22,17.0751322 17.0751322,22 11,22 C10.0668273,22 9.14843016,21.883561 8.26068071,21.6559496 Z"
            id="Combined-Shape"
            fill={color || "var(--color-easil-gray-x-dark)"}
            fillRule="nonzero"
          />
          <path
            d="M8.94018986,8.34381646 C8.75205358,8.86306899 8.17860165,9.13149174 7.65934913,8.94335545 C7.1400966,8.75521917 6.87167385,8.18176724 7.05981014,7.66251471 C7.72521511,5.82600979 9.64354018,4.73140304 11.5987573,5.05701485 C13.5604037,5.38369737 15.0029974,7.04751916 14.9999965,9.00237419 C14.9999965,10.2902987 14.2197623,11.3003361 12.9996317,12.0900846 C12.334976,12.5202933 11.6822126,12.8019674 11.220429,12.9514157 C10.6949766,13.1214693 10.1311576,12.8333617 9.96110404,12.3079093 C9.79105043,11.7824569 10.0791581,11.2186379 10.6046105,11.0485843 C10.6727684,11.0265262 10.8125585,10.9748226 10.9987402,10.8944832 C11.3126691,10.7590196 11.6261545,10.596693 11.9128846,10.4111025 C12.622427,9.9518402 12.9999965,9.46306473 12.9999977,9.00083973 C13.0014815,8.03385046 12.2762335,7.19738245 11.2702123,7.02984485 C10.2577618,6.86123653 9.27396828,7.42259445 8.94018986,8.34381646 Z"
            id="Path"
            fill={color || "var(--color-easil-gray-x-dark)"}
            fillRule="nonzero"
          />
          <path
            d=""
            stroke="#000000"
            strokeWidth="2.4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <circle
          fill={color || "var(--color-easil-gray-x-dark)"}
          cx="10.7"
          cy="15.6"
          r="1.1"
        />
      </g>
    </g>
  </svg>
);
ChatIcon.propTypes = {
  className: PropTypes.string,
  width: PropTypes.string,
  size: PropTypes.string,
  height: PropTypes.string,
  style: PropTypes.object,
  color: PropTypes.string
};

export default ChatIcon;
